import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { getEnrollmentRequiredDocuments } from "../services/school/enrollmentRequiredDocument/getEnrollmentRequiredDocuments";
import { Key_enrollmentRequiredDocuments } from "../utils/constants";

export const useGetEnrollmentRequiredDocumentsQuery = (data: PagedRequestType) =>
  useQuery(
    [Key_enrollmentRequiredDocuments, JSON.stringify(data)],
    () => getEnrollmentRequiredDocuments(data)
  );